import "../../style/common/title.scss";

export default function Title({ title, showBadge = false, className }) {
    return (<div >
        <h2 className={className}>{title}</h2>
        {showBadge && <div className="try-it-yourself">Try It Yourself</div>}
    </div>)
}
